import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Shield, Lock, Eye, UserCheck } from 'lucide-react';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-rose-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16">
        <div className="container max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-amber-200 rounded-full px-4 py-2 mb-6">
            <Shield className="h-4 w-4 text-amber-600" />
            <span className="body-small text-amber-800 font-mono uppercase tracking-wider">
              Kebijakan Privasi
            </span>
          </div>
          
          <h1 className="heading-hero mb-6">
            Kebijakan Privasi<br />
            Desy Clare
          </h1>
          
          <p className="body-large text-gray-600 mb-8 max-w-2xl mx-auto">
            Komitmen kami untuk melindungi privasi dan keamanan data pribadi Anda.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="pb-16">
        <div className="container max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12">
            
            {/* Last Updated */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-8">
              <p className="body-small text-amber-800">
                <strong>Terakhir diperbarui:</strong> Oktober 2025
              </p>
            </div>

            {/* Introduction */}
            <div className="mb-10">
              <h2 className="heading-2 mb-4">Pendahuluan</h2>
              <p className="body-medium text-gray-700 mb-4">
                Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi 
                pribadi Anda saat menggunakan platform numerologi kami.
              </p>
            </div>

            {/* Information Collection */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <UserCheck className="h-4 w-4 text-blue-600" />
                </div>
                <h3 className="heading-3">Informasi yang Kami Kumpulkan</h3>
              </div>
              
              <div className="space-y-4 ml-11">
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Data Numerologi:</h4>
                  <ul className="body-medium text-gray-700 space-y-1">
                    <li>• Tanggal lahir</li>
                    <li>• Nama lengkap</li>
                    <li>• Jenis Kelamin</li>
                    <li>• Data tambahan yang Anda berikan untuk analisis numerologi</li>
                    <li>• Hasil perhitungan numerologi Anda</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Informasi Teknis:</h4>
                  <ul className="body-medium text-gray-700 space-y-1">
                    <li>• Kami tidak mengambil dan tidak merekam data teknis apapun</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* How We Use Information */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <Eye className="h-4 w-4 text-green-600" />
                </div>
                <h3 className="heading-3">Bagaimana Kami Menggunakan Informasi</h3>
              </div>
              
              <div className="ml-11 space-y-3">
                <p className="body-medium text-gray-700">
                  <strong>Untuk Layanan Numerologi:</strong> Menghitung dan memberikan analisis 
                  numerologi yang personal dan akurat.
                </p>
                <p className="body-medium text-gray-700">
                  <strong>Peningkatan Layanan:</strong> Menganalisis penggunaan untuk meningkatkan 
                  kualitas platform dan pengalaman pengguna.
                </p>
                <p className="body-medium text-gray-700">
                  <strong>Komunikasi:</strong> Mengirim update layanan, tips numerologi, dan 
                  informasi penting lainnya (dengan persetujuan Anda).
                </p>
              </div>
            </div>

            {/* Data Security */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                  <Lock className="h-4 w-4 text-purple-600" />
                </div>
                <h3 className="heading-3">Keamanan Data</h3>
              </div>
              
              <div className="ml-11 space-y-3">
                <p className="body-medium text-gray-700">
                  Kami menggunakan enkripsi SSL dan protokol keamanan terdepan untuk melindungi 
                  data Anda. Informasi numerologi Anda disimpan dengan aman dan tidak akan 
                  dibagikan kepada pihak ketiga tanpa persetujuan eksplisit dari Anda.
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-gradient-to-r from-amber-50 to-rose-50 rounded-xl p-8">
              <h3 className="heading-3 mb-4">Hubungi Kami</h3>
              <p className="body-medium text-gray-700 mb-4">
                Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, silakan hubungi kami:
              </p>
              <div className="space-y-2">
                <p className="body-medium text-gray-700">
                  <strong>Email:</strong> desyclare@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;